import type { PaymentMethodType } from '../../../../../services/customer/types';
import type { FormattedPaymentMethod } from '../types';

export default function isManufacturerCard(
  formattedPaymentMethod: FormattedPaymentMethod<PaymentMethodType>,
) {
  return (
    formattedPaymentMethod.type === 'CARD' &&
    !!formattedPaymentMethod.cardCategories?.some(
      (category) => category.type === 'MANUFACTURER_CARD',
    )
  );
}
